<template>
<div class="chapter">
<div class="inner_page">
<p class="ch-title">Abbreviations</p>
<p class="para">Unless listed below, all abbreviations used in this volume are found in <em>The SBL Handbook of Style</em>, 2nd ed. (Atlanta: SBL Press, 2014).</p>
<div class="inside">
<table>
<tbody>
<tr><td class="td40"><p class="ab-fm"><em>AG</em></p></td>
<td class="td55"><p class="ab-fm"><em>The Apocryphal Gospels: Texts and Translations.</em> Edited and translated by Bart Ehrman and Zlatko Pleše. Oxford: Oxford University Press, 2011.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>ANT</em></p></td>
<td class="td55"><p class="ab-fm"><em>The Apocryphal New Testament: A Collection of Apocryphal Christian Literature in an English Translation</em>. Edited and translated by James K. Elliott. Rev. ed. Oxford: Clarendon, 2005.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>BHG</em></p></td>
<td class="td55"><p class="ab-fm"><em>Bibliotheca Hagiographica Graeca.</em> Edited by François Halkin. 3rd ed. 3 vols. Subsidia Hagiographica 8/8a. Brussels: Société des Bollandistes, 1986.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>BHL</em></p></td>
<td class="td55"><p class="ab-fm"><em>Bibliotheca Hagiographica Latina Antiquae et Mediae Aetatis.</em> 2 vols. Subsidia Hagiographica 6. Brussels: Société des Bollandistes, 1898–1901.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>BHO</em></p></td>
<td class="td55"><p class="ab-fm"><em>Bibliotheca Hagiographica Orientalis.</em> Edited by Paul Peeters. Subsidia Hagiographica 10. Brussels: Société des Bollandistes, 1910.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>CANT</em></p></td>
<td class="td55"><p class="ab-fm"><em>Clavis apocryphorum Novi Testamenti</em>. Edited by Maurice Geerard. Corpus Christianorum. Turnhout: Brepols, 1992.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>CPC</em></p></td>
<td class="td55"><p class="ab-fm"><em>Clavis Patrum Copticorum</em>. Online at <a href="http://cmcl.aai.uni-hamburg.de/" target="_blank">http://cmcl.aai.uni-hamburg.de/</a>.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>DMLBS</em></p></td>
<td class="td55"><p class="ab-fm"><em>Dictionary of Medieval Latin from British Sources.</em> Edited by Richard Ashdowne, David Howlett, and Ronald Latham. Oxford: Oxford University Press, 2018.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>EAC</em></p></td>
<td class="td55"><p class="ab-fm">Écrits <em>apocryphes chrétiens.</em> Vol. 1 edited by François Bovon and Pierre Geoltrain. Bibliothèque de la Pléiade 442. Paris: Gallimard, 1997. Vol. 2 edited by Pierre Geoltrain and Jean-Daniel Kaestli. Bibliothèque de la Pléiade 443. Paris: Gallimard, 2005.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>HUAA</em></p></td>
<td class="td55"><p class="ab-fm"><em>Die handschriftliche</em> Überlieferung <em>der altslavischen Apokryphen</em>. 2 vols. Edited by Aurelio de Santos Otero. PTS 20 and 23. Berlin: de Gruyter, 1978, 1981.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Lampe</p></td>
<td class="td55"><p class="ab-fm">Lampe, G. W. H., ed. <em>A Patristic Greek Lexicon.</em> Oxford: Clarendon, 1961.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">LSJ</p></td>
<td class="td55"><p class="ab-fm">Liddell, Henry George, Robert Scott, and Henry Stuart Jones, eds. <em>A Greek-English Lexicon</em>. 9th ed. with revised supplement. Oxford: Clarendon, 1996.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>MNTA</em></p></td>
<td class="td55"><p class="ab-fm"><em>New Testament Apocrypha: More Noncanonical Scriptures</em>. Vol. 1 edited by Tony Burke and Brent Landau. Vol. 2 edited by Tony Burke<em>.</em> Grand Rapids: Eerdmans, 2016, 2019.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">P. Oxy.</p></td>
<td class="td55"><p class="ab-fm"><em>The Oxyrhynchus Papyri.</em> Edited by B. P. Grenfell<em></em> et al.<em></em> London: Egypt Exploration Society, 1898–.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">TLG</p></td>
<td class="td55"><p class="ab-fm">Thesaurus Linguae Graecae</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts Andr. Bart.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of Andrew and Bartholomew</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts Andr. Paul</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of Andrew and Paul</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts Andr. Phlm.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of Andrew and Philemon</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts Chr. Pet.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of Christ and Peter in Rome</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts John Proch.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of John by Prochorus</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts John Rome</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of John in Rome</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts Matt. Priests</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of Matthew in the City of the Priests</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts Ner. Ach.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of Nereus and Achilleus</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts Pet. Andr.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of Peter and Andrew</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts Pet. Paul</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of the Holy Apostles Peter and Paul</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts Thad.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of Thaddaeus</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts Thom. Skin</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of Thomas and His Wonderworking Skin</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts Tim.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of Timothy</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Acts Titus</em></p></td>
<td class="td55"><p class="ab-fm"><em>Acts of Titus</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Adso of Montieren-Der</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>De ortu</em></p></td>
<td class="td55"><p class="ab-fm"><em>De ortu et tempore Antichristi</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Apoc. Anast.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Apocalypse of Anastasia</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Apoc. Ps.-Ephrem</em></p></td>
<td class="td55"><p class="ab-fm"><em>Apocalypse of Pseudo-Ephrem</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Apoc. Ps.-Meth.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Apocalypse of Pseudo-Methodius</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>1 Apocr. Apoc. John</em></p></td>
<td class="td55"><p class="ab-fm"><em>1 Apocryphal Apocalypse of John</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>2 Apocr. Apoc. John</em></p></td>
<td class="td55"><p class="ab-fm"><em>2 Apocryphal Apocalypse of John</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>3 Apocr. Apoc. John</em></p></td>
<td class="td55"><p class="ab-fm"><em>3 Apocryphal Apocalypse of John</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Apos. Con.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Apostolic Constitutions</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Athanasius</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Quaest. ad Ant.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Quaestiones ad Antiochem ducem</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Birth Bapt.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Birth of Holy John the Forerunner</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Birth Sav.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Book about the Birth of the Savior</em> (<em>Liber de Nativitate Salvatoris</em>)</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Bk. Bart.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Book of Bartholomew</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Chron. Pasch.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Chronicon Paschale</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Comm. Jn. Ev.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Commentariolus de Ioannis evangelio</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Commodian</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Instr.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Instructiones</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Cosm. et Dam.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Vitae et miracula sanctorum Cosmae et Damiani</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>7 Dan</em></p></td>
<td class="td55"><p class="ab-fm"><em>Seventh Vision of Dan</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Decap. Bapt.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Decapitation of John the Baptist</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>DEH</em></p></td>
<td class="td55"><p class="ab-fm"><em></em>Pseudo-Hegesippus, <em>De Excidio Hierosolymitano</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Dial. Devil</em></p></td>
<td class="td55"><p class="ab-fm"><em>Dialogue of Jesus and the Devil</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Dial. Mary Chr.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Dialogue of Mary and Christ on the Departure of the Soul</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Dial. Urs. Patr.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Dialogue of Ursinius and Patrophilius</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Diodorus Siculus</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Bib. hist.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Bibliotheca historica</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Disp. Pet. Nero</em></p></td>
<td class="td55"><p class="ab-fm"><em>Disputation of Peter and Nero</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Doctr. Addai</em></p></td>
<td class="td55"><p class="ab-fm"><em>Doctrina Addai</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Dream Rood</em></p></td>
<td class="td55"><p class="ab-fm"><em>Dream of the Rood</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Egeria</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Itin.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Itinerarium</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Encom. Mary</em></p></td>
<td class="td55"><p class="ab-fm"><em>Encomium on Mary Magdalene</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Ep. Chr. Heav.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Epistle of Christ from Heaven</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Ep. Herod Pil.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Epistle of Herod to Pilate</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Ep. Ign. John Mary</em></p></td>
<td class="td55"><p class="ab-fm"><em>Correspondence of Ignatius with John the Evangelist and the Virgin Mary</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Ep. Jas. Quad.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Epistle of James to Quadratus</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Ep. Long. Aug.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Epistles of Longinus and Augustus</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Ep. Pil. Claud.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Epistle of Pilate to Claudius</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Ep. Tim. Dion.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Epistle of Pseudo-Dionysius the Areopagite to Timothy</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Ephrem</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Hymn Nat.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Hymns on the Nativity</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Epiphanius</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>De mens. et pond.</em></p></td>
<td class="td55"><p class="ab-fm"><em>De mensuribus et ponderibus</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Erem. Life Magd.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Eremitic Life of Mary Magdalene</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Gos. Jud.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Gospel of Judas</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Gos. Twelve (Syr.)</em></p></td>
<td class="td55"><p class="ab-fm"><em>Gospel of the Twelve Apostles (Syriac)</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Gregory of Tours</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Glor. mart</em>.</p></td>
<td class="td55"><p class="ab-fm"><em>Liber in gloria martyrum</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Lib. de mir.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Liber de miraculis Andreas Apostoli</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Gregory Referendarius</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Hom. Im. Ed.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Homily on the Image of Edessa</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Gregory the Great</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Hom. in Euang.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Homiliae in Euangelia</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Heal. Tib.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Healing of Tiberius</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Heiric of Auxerre</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Hom.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Homiliae</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Herodian</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Hist.</em></p></td>
<td class="td55"><p class="ab-fm"><em>History of the Empire from the Death of Marcus</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Hippocrates</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Aer.</em></p></td>
<td class="td55"><p class="ab-fm"><em>De aeare acquis et locis</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Hist. John</em></p></td>
<td class="td55"><p class="ab-fm"><em>(Syriac) History of John</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Hist. Paul</em></p></td>
<td class="td55"><p class="ab-fm"><em>History of Paul</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Hist. Phil.</em></p></td>
<td class="td55"><p class="ab-fm"><em>History of Philip</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Hist. Sim. Ceph.</em></p></td>
<td class="td55"><p class="ab-fm"><em>History of Simon Cephas, the Chief of the Apostles</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Hist. Vir.</em></p></td>
<td class="td55"><p class="ab-fm"><em>(East Syriac) History of the Virgin</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Hom. Life Jesus</em></p></td>
<td class="td55"><p class="ab-fm"><em>Homily on the Life of Jesus and His Love for the Apostles</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Hom.</em> <em>Pass. Res</em>.</p></td>
<td class="td55"><p class="ab-fm"><em>Homily on the Passion and Resurrection</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Hosp. Dysmas</em></p></td>
<td class="td55"><p class="ab-fm"><em>Hospitality of Dysmas</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Hosp. Oint. Band.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Hospitality and Ointment of the Bandit</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Hosp. Perf. Band.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Hospitality and Perfume of the Bandit</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Invest. Abbat.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Investiture of Abbaton</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Invest. Gab.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Investiture of the Archangel Gabriel</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Invest. Mich.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Investiture of the Archangel Michael</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Leg. Rood Tree</em></p></td>
<td class="td55"><p class="ab-fm"><em>Legend of the Holy Rood Tree</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Libanius</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Or.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Orationes</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Liber Requiei</em></p></td>
<td class="td55"><p class="ab-fm"><em>Liber Requiei Mariae</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Life Bapt. Serap.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Life of John the Baptist</em> by Serapion</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Life Mart. Bapt.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Life and Martyrdom of John the Baptist</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Lin. Mart. Paul</em></p></td>
<td class="td55"><p class="ab-fm"><em></em>Pseudo-Linus, <em>Martyrdom of Blessed Paul the Apostle</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Lin. Mart. Pet.</em></p></td>
<td class="td55"><p class="ab-fm"><em></em>Pseudo-Linus, <em>Martyrdom of Blessed Peter the Apostle</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Mart. Mark</em></p></td>
<td class="td55"><p class="ab-fm"><em>Martyrdom of Mark</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Mart. Paul Head</em></p></td>
<td class="td55"><p class="ab-fm"><em>Martyrdom of Paul the Apostle and the Discovery of His Severed Head</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Mart. Phil. (Copt.)</em></p></td>
<td class="td55"><p class="ab-fm"><em>(Coptic) Martyrdom of Philip</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Mart. Pil.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Martyrdom of Pilate</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Mart. Zech.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Martyrdom of Zechariah</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Mem. John</em></p></td>
<td class="td55"><p class="ab-fm"><em>Memorial of John</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Myst. John</em></p></td>
<td class="td55"><p class="ab-fm"><em>Mysteries of John</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Nicephorus Callistus</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Hist. eccl.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Historia ecclesiastica</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Oecumenicus</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Comm. Apoc.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Commentaria in Apocalypsi</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Palladius of Helenopolis</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Hist. Laus.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Historia Lausiaca</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Parad. Pil.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Handing Over of Pilate</em> (<em>Paradosis Pilati</em>)</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Pass. Apost. Pet. Paul</em></p></td>
<td class="td55"><p class="ab-fm"><em>Passion of the Apostles Peter and Paul</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Pass. Holy Pet. Paul</em></p></td>
<td class="td55"><p class="ab-fm"><em>Passion of the Holy Apostles Peter and Paul (Pseudo-Marcellus)</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Pass. Paul</em></p></td>
<td class="td55"><p class="ab-fm"><em></em>Pseudo-Abdias, <em>Passion of Paul</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Pass. Pet.</em></p></td>
<td class="td55"><p class="ab-fm"><em></em>Pseudo-Abdias, <em>Passion of Peter</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Pass. Pet. Paul</em></p></td>
<td class="td55"><p class="ab-fm"><em></em>Pseudo-Hegesippus, <em>Passion of Peter and Paul</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Paulinus of Nola</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Carm.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Carmina</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Photius of Constantinople</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Bib</em>.</p></td>
<td class="td55"><p class="ab-fm"><em>Bibliotheca</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Pre. Bart.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Preaching of Bartholomew</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Pre. Jas. Zeb.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Preaching of James, Son of Zebedee</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Pre. Pet. Faust.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Preaching of Peter to Faustus</em>[tab/]<em></em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Pre. Pet. Rome</em></p></td>
<td class="td55"><p class="ab-fm"><em>Preaching of Simon Cephas in the City of Rome</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Pre. Phil.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Preaching of Philip</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Procopius</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Wars</em></p></td>
<td class="td55"><p class="ab-fm"><em>History of the Wars</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Prudentius</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Perist.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Peristephanon</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Pseudo-Clement</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Hom.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Homilies</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Rec.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Recognitions</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Pseudo-Dionysius</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Ep.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Epistles</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Pseudo-Melito</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Pass. John</em></p></td>
<td class="td55"><p class="ab-fm"><em>Passion of John</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Ptolemy</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Geog.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Geographia</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Quest. Bart.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Questions of Bartholomew</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Quest. Jas.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Questions of James to John</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Quest. John</em></p></td>
<td class="td55"><p class="ab-fm"><em>Questions of John</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Reb. Dimas</em></p></td>
<td class="td55"><p class="ab-fm"><em>Rebellion of Dimas</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Report Pil.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Report of Pilate</em> (<em>Anaphora Pilati</em>)</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Rev. John Ant.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Revelation of John about the Antichrist</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>1</em> <em>Rev. Matt. End</em></p></td>
<td class="td55"><p class="ab-fm"><em>1</em> <em>Revelation of Matthew about the End Times</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>2</em> <em>Rev. Matt. End</em></p></td>
<td class="td55"><p class="ab-fm"><em>2</em> <em>Revelation of Matthew about the End Times</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Rev. Prayer</em></p></td>
<td class="td55"><p class="ab-fm"><em>Revelation about the Lord’s Prayer</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>SGP</em></p></td>
<td class="td55"><p class="ab-fm"><em>Sayings of Greek Philosophers</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">Solomon of Basra</p></td>
<td class="td55"><p class="ab-fm"></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm1"><em>Bk. Bee</em></p></td>
<td class="td55"><p class="ab-fm"><em>Book of the Bee</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Story Im. Ed.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Story of the Image of Edessa</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Story Jos. Arim.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Story of Joseph of Arimathea</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Teach. Apos.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Teaching of the Apostles</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Testim. Urs.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Testimony of Ursinius</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Tib. Sib.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Tiburtine Sibyl</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Vis. Theo.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Vision of Theophilus</em></p></td>
</tr>
<tr><td class="td40"><p class="ab-fm"><em>Xanth.</em></p></td>
<td class="td55"><p class="ab-fm"><em>Life and Conduct of the Holy Women Xanthippe, Polyxena, and Rebecca</em></p></td>
</tr>
</tbody>
</table>
</div>
<p class="h1">Sigla</p>
<div class="inside">
<table>
<tbody>
<tr><td class="td40"><p class="ab-fm">[text]</p></td>
<td class="td55"><p class="ab-fm">Square brackets indicate damaged, illegible, or missing text, whether restorable or unrecoverable.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">(text)</p></td>
<td class="td55"><p class="ab-fm">Parentheses or round brackets indicate words added by the translator for clarity.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">&lt;text&gt;</p></td>
<td class="td55"><p class="ab-fm">Pointed brackets indicate a correction or emendation made to a text by the translator.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">{text}</p></td>
<td class="td55"><p class="ab-fm">Braces enclose dittographies (double writings) or other erroneous readings in a manuscript or text.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">{…}</p></td>
<td class="td55"><p class="ab-fm">Braces containing three ellipsis points indicate that a textual tradition (i.e., involving more than one manuscript) has lost one or more words in transmission and that the original reading cannot be reconstructed with any confidence.</p></td>
</tr>
<tr><td class="td40"><p class="ab-fm">†…†</p></td>
<td class="td55"><p class="ab-fm">Cruces containing three ellipsis points indicate that a reading in an individual manuscript cannot be reconstructed with any confidence.</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Abbreviations.vue?2f59a33a